// extracted by mini-css-extract-plugin
module.exports = {"root":"LineChart_root__3h73t"};